import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from "../../apa/Launcher";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import AAF from "../../../AAF/AAF";
import { EPG_VERSION_TTL } from "../../../AAF/Resilence/TTLConstants";

const TTLItem = EPG_VERSION_TTL;

class EpgChannel extends AbstractRequestTask {

  constructor(parameters = {}) {
    super();
    this.parameters = parameters;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();

    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'EpgChannelTask[getParams]');

    this.parameters.epg_version = DeviceStorage.getItem('epgVersion') || false;
    this.parameters.soa_version =DeviceStorage.getItem('soaVersion') || false;
    delete params.user_token;
    return {
      ...params,
      ...this.parameters
    };
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/epg/channel`;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default EpgChannel;



// WEBPACK FOOTER //
// ./src/requests/tasks/epg/EpgChannelTask.js